module.exports = __webpack_public_path__ + "static/media/home-salmon.20ce264b.svg";